import { axiosWithAuth } from "../../helpers";

export const applicationEditService = {
	getApplication,
	saveApplication,
	submitApplication,
	finalizeApplication,
	getApplicationHistory,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getApplication(id) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/${id}`,
	};

	return axiosWithAuth(options);
}

function saveApplication(editedApplication) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/save-app`,
		data: editedApplication,
	};

	return axiosWithAuth(options);
}

function submitApplication(editedApplication) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/submit-app`,
		data: editedApplication,
	};

	return axiosWithAuth(options);
}

function finalizeApplication(editedApplication) {
	//To Flow
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/${editedApplication.id}/finalize`,
		data: editedApplication,
	};

	return axiosWithAuth(options);
}

function getApplicationHistory({ page, id }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			applicationId: id,
		},
		url: `${API_URL}/api/modifications/applications/${id}`,
	};

	return axiosWithAuth(options);
}
